import {
  priceBedsideAddons,
  type BedsidePricing,
} from "../src/config/blissBedsideAddons.js";
import {
  guardrailOption,
  isBasicGuardrailStyle,
} from "../src/config/blissGuardrails.js";

export const PLAN_EXCLUSIONS = [
  "Mattresses, bedding and décor shown in the preview are not supplied.",
  "Electrical work and site modifications are excluded unless separately quoted.",
];
export function planReviewItems(
  plan: any,
  bedsidePricing?: BedsidePricing,
): string[] {
  const rooms = plan.layout?.rooms?.length
    ? plan.layout.rooms
    : [
        {
          name: "Your room",
          configuratorSnapshot: plan.layout?.configuratorSnapshot,
        },
      ];
  return rooms.flatMap((room: any, index: number) => {
    const s = room.configuratorSnapshot;
    if (!s) return [];
    const label = room.name || `Room ${index + 1}`;
    const items = priceBedsideAddons(s.bedsideAddons, s.beds, bedsidePricing)
      .lines.filter((line) => line.pending)
      .map(
        (line) =>
          `${label}: ${line.label} — price and any electrical allowance need confirmation`,
      );
    if (
      s.guardrailStyle &&
      (!isBasicGuardrailStyle(s.guardrailStyle) ||
        guardrailOption(s.guardrailStyle).pricePerBunk === null)
    )
      items.push(`${label}: selected guardrail requires a confirmed price`);
    const f = s.finish;
    if (s.beds?.some((bed: any) => bed.designerDimensions))
      items.push(`${label}: designer-adjusted dimensions require a confirmed scope and price`);
    if (
      f?.treatment !== "unfinished_raw" &&
      [
        f?.frameId,
        f?.accentId,
        f?.topRailId,
        ...Object.values(f?.railColors ?? {}),
      ].some((id) =>
        ["natural_maple", "espresso", "white_oak", "walnut"].includes(
          id as string,
        ),
      )
    )
      items.push(
        `${label}: selected wood finish or stain requires a separate confirmed allowance`,
      );
    return items;
  });
}

